import { mapActions, mapGetters } from 'vuex';
import { smartatob } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['clearRefreshToken', 'setUseDisqus', 'loginDisqus', 'logoutDisqus']),
  },
  created() {
    if (this.$route.name === 'disqus-logout') {
      this.logoutDisqus()
        .then(() => {
          this.setUseDisqus(false);
          this.$router.push({
            name: smartatob(this.$route.params.routeName),
            params: JSON.parse(smartatob(this.$route.params.routeParams)),
          });
        });
    } else if (this.isLoggedIn) {
      // remember that from now onwards we should login with disqus
      this.loginDisqus()
        .then(() => {
          this.setUseDisqus(true);
          setTimeout(() => { window.close(); }, 1000);
        });
    } else {
      this.setCurrentPopup(MODALS.LOGIN);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-disqus/account-disqus.js